// Options for the chart that shows status
// =============================================================================
import Highcharts from 'highcharts/highstock';

export default {
  chart: {
    height: 300,
    panning: false,
    spacingTop: 10,
    spacingLeft: 10,
    spacingRight: 10
  },
  tooltip: {
    shared: true,
    useHTML: true,
    footerFormat: '</tbody></table>',
    borderWidth: 0,
    valueDecimals: 2,
    formatter() {
      const dateFormat = '%A %e. %b kl. %H:%M';
      let format = `${'<span style="font-size: 10px">%d</span><br>' +
        '<span style="color:'}${
        Highcharts.getOptions().colors[0]
      }">●</span> <b>%n kr</b><br>`;

      const formattedDate = Highcharts.dateFormat(dateFormat, this.x);
      format = format.replace('%d', formattedDate);
      format = format.replace(
        '%n',
        Highcharts.numberFormat(this.points[0].y.toFixed(2))
      );

      return format;
    }
  },
  series: [
    {
      // Today
      type: 'area',
      threshold: null,
      tooltip: {
        valueDecimals: 2
      },
      fillColor: {
        linearGradient: {
          x1: 0,
          y1: 0,
          x2: 0,
          y2: 1
        },
        stops: [
          [0, Highcharts.getOptions().colors[0]],
          [
            1,
            Highcharts.Color(Highcharts.getOptions().colors[0])
              .setOpacity(0)
              .get('rgba')
          ]
        ]
      }
    }
  ],
  xAxis: {
    type: 'datetime',
    showFirstLabel: true,
    startOnTick: false,
    dateTimeLabelFormats: {
      millisecond: '%H:%M',
      second: '%H:%M',
      minute: '%H:%M',
      hour: '%H:%M',
      day: '%e. %b',
      week: '%e. %b',
      month: "%b '%y",
      year: '%Y'
    },
    crosshair: {
      color: '#cccccc',
      dashStyle: 'Solid'
    }
  },
  yAxis: {
    offset: 0,
    endOnTick: false,
    startOnTick: false,
    tickPosition: 'inside',
    gridLineWidth: 0,
    opposite: true,
    title: {
      text: null
    }
  },

  title: {
    margin: 50,
    text: null
  }
};
